import { limitLines } from 'src/styles'
import styled from 'styled-components'

export const PostTitle = styled.h2`
  ${limitLines(1)}
`

PostTitle.displayName = 'PostTitle'

export const ViewMore = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

ViewMore.displayName = 'ViewMore'
